module.exports = __webpack_public_path__ + "img/transfer2.a9826f64.png";